import merge from 'lodash/merge'
import { queries } from './graphql'
import { jsonStringify, jsonTryParse } from '@ztechapps/common.utils'
import { useMutation } from '../useMutation'
import type { Template } from '@ztechapps/common.contract'
import { useDeleteTemplate } from './useDeleteTemplate'

export type UseManageTemplateProps = {
  category: string
  initialValues?: any
  onFilter?: (props: { template: Record<any, any> }) => void
}
type UseManageTemplate = {
  onAddSubmit: (template: Template) => Promise<Template>
  onUpdateSubmit: (template: Template) => Promise<Template>
  onDeleteSubmit: (templateId: string) => Promise<void>
  validate: (values: Template) => any
  initialValues: Template
  onApply: any
}
export const useManageTemplate = ({ category, initialValues, onFilter }: UseManageTemplateProps): UseManageTemplate => {
  const mutationOptions = { refetchQueries: ['allTemplate'] }
  const [onAdd] = useMutation({ ...queries.createConfig, options: { mutationOptions } })
  const [onEdit] = useMutation({ ...queries.updateConfig, options: { mutationOptions } })

  const defaultInitialValues = {
    value: 'Sample value',
    name: 'New template',
    description: '[TODO] freshly created template',
    scope: { key: 'tenant' },
    filter: null,
    isDefault: false,
    category,
  }

  initialValues = merge({}, defaultInitialValues, initialValues)

  const validate = (values: Template) => {
    const errors: any = {}
    if (!values.name) errors.name = 'Required'
    if (!values.description) errors.description = 'Required'
    if (!values?.value) {
      errors.value = 'Required'
    }

    return errors
  }

  const buildInput = (template: Template) => {
    let value = template.value
    let filter = template.filter

    //TODO: I think this should be from outside
    //as the query value and text value should have conversion mapping needed
    //or the value converter should done from the outside
    //there is a filter so value should be properly be handled
    if (template.filter) {
      //if there is no changes on value(jsut click the save with no change), just set the value as the current value
      const templateFilter = jsonTryParse(template?.filter)

      //value = template?.filter?.mongodbValue ? jsonStringify(template?.filter?.mongodbValue ?? {}) : template?.value ?? '{}'
      value = templateFilter?.mongodbValue
        ? jsonStringify(templateFilter?.mongodbValue ?? {})
        : (template?.value ?? '{}')

      //value = Utils.jsonStringify(template?.filter?.mongodbValue ?? {})
      filter = jsonStringify(templateFilter?.value)
    }

    return {
      category,
      ...template,
      value,
      filter,
    }
  }

  const onAddSubmit = async (template: Template) => {
    //do the submission here
    const input = buildInput(template)

    const { errors, data } = await onAdd({ input })
    if (errors) throw errors

    return data?.createTemplate
  }

  const onUpdateSubmit = async (template: Template) => {
    //do the submission here
    const input = buildInput(template)

    const { errors, data } = await onEdit({ input })
    if (errors) throw errors
    return data?.updateTemplate
  }

  const onApply = !onFilter
    ? null
    : async (template: Template) => {
        //do the submission here
        if (!template?.value) return
        const input = buildInput(template)
        onFilter?.({ template: input })
      }

  const { onDelete: onDeleteSubmit } = useDeleteTemplate()

  return { onAddSubmit, onUpdateSubmit, validate, initialValues, onApply, onDeleteSubmit }
}
